module.exports = __webpack_public_path__ + "img/signature-error.1659b4bf.webp";